import toastr from 'toastr';
import Service from "../../../utility/Service"

export const PAYMENTS_GET_SUCCESS = "PAYMENTS_GET_SUCCESS";
export const PAYMENTS_GET_FAILURE = "PAYMENTS_GET_FAILURE";
export const PAYMENTS_GET_REQUEST = "PAYMENTS_GET_REQUEST";

export const paymentsGetFailure = () => ({
    type: PAYMENTS_GET_FAILURE,
    loading: true,
    paymentData: []
});


export const paymentsGetSuccess = (data, pageNo, pageSize) => ({
    type: PAYMENTS_GET_SUCCESS,
    loading: false,
    paymentData: data
});



export const paymentsGetRequest = () => ({
    type: PAYMENTS_GET_REQUEST,
    loading: true,
    paymentData: []
});

export const getpayments = (value, pageNo, pageSize) => (dispatch, getState) => {
    toastr.remove()
    dispatch(paymentsGetRequest())
    //let url = "payment/charges?offset=0&limit=" + 1000
    let url = "payment/charges/filter"
    // if (pageNo && pageSize) {
    //     url = "payment/charges?offset=0&limit=" + 50 + "?page=" + pageNo + "&page_size=" + pageSize
    // }
    Service.post(url,value,
        (response) => {
            if (response && response.status && response.status === 200) {
                // toastr.success(response.message ? response.message : 'Locale.actions.usersReceivedSuccessfully');
                console.log(response);
                let data = {
                    data: response.data,
                    pagination: response.pagination
                }
                dispatch(paymentsGetSuccess(data));
            } else {
                console.log("plans", response);
                dispatch(paymentsGetFailure());
                // toastr.error(response && response.message && response.message.non_field_errors ? response.message.non_field_errors.join() : response.message ? response.message : 'Something Went Wrong');
                toastr.error('Something Went Wrong');
            }
        }
    )
};





